/* Hide Shopify's default "Orders / Profile" quick-link strip inside the
   <shopify-account> sheet for SIGNED-OUT customers. Those defaults expose
   private routes before authentication. Signed-in customers never see this
   sheet (the header swaps in a regular <a href="/pages/account"> link), so
   hiding the region is safe in every state we use the component.

   The region is rendered inside the component's shadow DOM, so we inject
   a small <style> rule into each shopify-account's shadowRoot once it
   becomes available. Poll briefly to handle the lazy component upgrade. */
(function () {
  'use strict';

  var CSS = '.account__menu-region { display: none !important; }';

  function tryInject() {
    var done = true;
    var nodes = document.querySelectorAll('shopify-account');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.__velvetyMenuHidden) continue;
      if (!el.shadowRoot) { done = false; continue; }
      var style = document.createElement('style');
      style.textContent = CSS;
      el.shadowRoot.appendChild(style);
      el.__velvetyMenuHidden = true;
    }
    return done;
  }

  if (tryInject() && document.querySelectorAll('shopify-account').length > 0) return;

  var attempts = 0;
  var interval = setInterval(function () {
    attempts++;
    if (tryInject() || attempts > 40 /* ~8s */) {
      clearInterval(interval);
    }
  }, 200);
})();
